import { api } from '../services/index';

export function getAuthorizers() {
  return api.get('/authorizers');
}

export function addAuthorizer(data) {
  return api.post('/authorizers', data);
}

export function getAuthorizer(authorizerID) {
  return api.get(`/authorizers/${authorizerID}`);
}

export function deleteAuthorizer(authorizerID) {
  return api.delete(`/authorizers/${authorizerID}`);
}

export function editAuthorizer(authorizerID, data) {
  return api.patch(`/authorizers/${authorizerID}`, data);
}

export function getIdpByEmail(email) {
  return api.get(`/authorizers/idp/${encodeURIComponent(email)}`);
}
